import { useEffect, useRef, useState } from 'react';
import { ExtremeGlyph } from './PriorityGlyphs.js';

const MAX_REASON_LENGTH = 500;

interface ExtremeReasonFormProps {
    onSubmit: (reason: string) => void;
    onBack: () => void;
}

export function ExtremeReasonForm({ onSubmit, onBack }: ExtremeReasonFormProps) {
    const [reason, setReason] = useState('');
    const textareaRef = useRef<HTMLTextAreaElement>(null);
    const trimmed = reason.trim();
    const valid = trimmed.length > 0 && trimmed.length <= MAX_REASON_LENGTH;

    useEffect(() => {
        textareaRef.current?.focus();
    }, []);

    return (
        <>
            <div className="flex items-center gap-2 px-3 pt-3 pb-2">
                <span className="flex items-center justify-center w-5 h-5 rounded bg-red-600 flex-shrink-0">
                    <ExtremeGlyph className="text-white" />
                </span>
                <span className="text-[13px] font-semibold text-red-700">Set Extreme</span>
            </div>

            <div className="px-3 pb-2">
                <textarea
                    ref={textareaRef}
                    rows={2}
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Why? Posted to the case timeline…"
                    className="w-full text-[12px] border border-gray-200 rounded-lg p-2 resize-none focus:outline-none focus:border-gray-400"
                    maxLength={MAX_REASON_LENGTH}
                />
            </div>

            <div className="flex gap-2 px-3 pb-3">
                <button
                    type="button"
                    onClick={() => valid && onSubmit(trimmed)}
                    disabled={!valid}
                    className="flex-1 py-1.5 rounded-md bg-red-600 text-white text-xs font-semibold disabled:bg-red-200 disabled:cursor-not-allowed"
                >
                    Set Extreme
                </button>
                <button
                    type="button"
                    onClick={onBack}
                    className="px-3 py-1.5 rounded-md border border-gray-200 bg-white text-xs font-semibold text-gray-700 hover:bg-gray-50"
                >
                    Back
                </button>
            </div>
        </>
    );
}
